import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { FC } from 'react';
import { COLORS } from 'shared/const/theme';
import { RoundContainer } from 'shared/ui';

type PasswordHintProps = {
  value?: string;
  label: string;
  regex: RegExp;
}

export const PasswordHints: FC<PasswordHintProps> = ({ value, label, regex }) => {
  const sanitizedValue = value || '';
  const isValid = regex.test(sanitizedValue);

  return (
    <Flex gap={4} align='center'>
      {isValid ? (
        <RoundContainer size={14} color={COLORS.SUCCESS}>
          <CheckOutlined style={{ color: '#fff', fontSize: 8 }} />
        </RoundContainer>
      ) : (
        <RoundContainer size={14} color={COLORS.ERROR}>
          <CloseOutlined style={{ color: '#fff', fontSize: 8 }} />
        </RoundContainer>
      )}
      <Typography.Text>{label}</Typography.Text>
    </Flex>
  )
}